module.exports = __webpack_public_path__ + "static/media/drager-logo.e5979a67.svg";